import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { BookOpenIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="bg-navy py-20 md:py-32 px-4 text-center" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-77">
          <BookOpenIcon className="w-16 h-16 text-amber mb-8" data-id="element-78" />

          <p className="font-body text-xl md:text-2xl text-cream leading-relaxed mb-12" data-id="element-79">
            Recuperar la paz en tu hogar y la conexión con tu hijo no tiene
            precio, pero queremos que esta herramienta sea accesible para todas
            las familias que la necesitan hoy mismo.
          </p>

          <CTAButton className="mb-6 w-full md:w-auto" data-id="element-80" />

          <p className="font-body text-sm text-cream/70 mt-4" data-id="element-81">
            *Tu compra es segura y recibirás el acceso de inmediato a tu correo
            electrónico.
          </p>
        </motion.div>
      </div>
    </section>;
}